import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "480px",
    maxWidth: "480px",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },
  card: {
    borderRadius: "10px",
    color: theme.palette.text.tertiary,
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "18px 8px 10px 18px",
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: "24px",
    fontWeight: "500",
    marginBottom: "10px",
  },
  closeIcon: {
    color: theme.palette.text.primary,
    cursor: "pointer",
  },
  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
    height: "340px",
    overflowY: "auto",
    overflowX: "hidden",
  },
  textFieldContainer: {
    marginTop: "10px",
    marginRight: "5px",
    width: "100%",
  },
  cardContentDiv2: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
  },
  cardContentInput1: {
    marginRight: "5px",
    padding: "3px 3px 3px 8px",
    height: "35px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
  },
  hrTimeline: {
    borderColor: theme.palette.text.tertiary,
    marginTop: "-1px",
  },
  submitBtn: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.secondary.main,
    padding: "10px",
    borderRadius: "10px",
    color: theme.palette.text.primary,
    width: "140px",
  },
  placeholder: {
    color: theme.palette.text.tertiary,
    fontSize: "14px",
    marginLeft: "5px",
    fontFamily: "Poppins, sans-serif",
  },
  userPlusIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    borderColor: theme.palette.text.tertiary,
    color: theme.palette.text.tertiary,
    border: "2px solid",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  paper: {
    background: theme.palette.secondary.light,
    color: theme.palette.text.primary,
  },
  input: {
    "&:focus": {
      background: "none",
    },
  },
  toolContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  seqModalCloseIcon: {
    cursor: "pointer",
    marginTop: "8px",
  },
  searchDiv: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "10px",
    width: "90%",
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.primary,
  },
  searchInput: {
    padding: "3px 9px",
  },
  sequenceModal: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "10px",
    minWidth: "350px",
    maxWidth: "350px",
  },
  sequenceList: {
    height: "250px",
    overflowY: "scroll",
    marginTop: "4%",
  },
  singleSequence: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    position: "relative",
  },
  check: {
    color: theme.palette.secondary.main,
  },
  hrSeq: {
    borderTop: 0,
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    margin: "10px 3px",
  },
  seqButtonDiv: {
    display: "flex",
    justifyContent: "center",
    marginTop: "15px",
  },
  seqButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    width: "85px",
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default useStyles;
